<div class="page-title-area">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="page-title-text">
                    <h2>PROGRAMME D'AMELIORATION CONTINU</h2>
                    <ul>
                        <li><a routerLink="/">ACCUEIL</a></li>
                        <li><i class="icofont-simple-right"></i></li>
                        <li>PROGRAMME D'AMELIORATION CONTINU</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- Main Content -->
<section class="main-content">
    <div class="container">
        <!-- Introduction -->
        <div class="row mb-5">
            <div class="col-lg-8 mx-auto">
                <div class="intro-card">
                    <div class="card-icon">
                        <i class="icofont-chart-line"></i>
                    </div>
                    <h2>Comment ça fonctionne ?</h2>
                    <p>
                        Engagez-vous dans ce processus complet et misez sur le développement des compétences de vos ressources humaines 
                        pour accroître votre compétitivité. Notre programme se déroule en 4 étapes clés.
                    </p>
                </div>
            </div>
        </div>

        <!-- Steps Grid -->
        <div class="row">
            <!-- Step 1 -->
            <div class="col-lg-6 mb-4">
                <div class="step-card">
                    <div class="step-header">
                        <div class="step-number">01</div>
                        <div class="step-icon">
                            <i class="icofont-search-document"></i>
                        </div>
                    </div>
                    <h3>Profilage - Évaluation complète et objective</h3>
                    <div class="step-content">
                        <div class="highlight-box">
                            <i class="icofont-check-circled"></i>
                            <span>Un de nos conseillers se rend dans votre entreprise (1 journée)</span>
                        </div>
                        
                        <div class="details-list">
                            <div class="detail-item">
                                <i class="icofont-location-pin"></i>
                                <span>Visite de l'usine et des bureaux</span>
                            </div>
                            <div class="detail-item">
                                <i class="icofont-users"></i>
                                <span>Discussion avec les employés et les dirigeants</span>
                            </div>
                            <div class="detail-item">
                                <i class="icofont-file-text"></i>
                                <span>Questionnaire portant sur tous les aspects de l'entreprise</span>
                            </div>
                        </div>

                        <div class="evaluation-areas">
                            <h4>Domaines d'évaluation :</h4>
                            <div class="areas-list">
                                <span class="area-tag">Approvisionnements</span>
                                <span class="area-tag">Fabrication</span>
                                <span class="area-tag">Gestion de la qualité</span>
                                <span class="area-tag">Ressources humaines</span>
                                <span class="area-tag">Ressources financières</span>
                                <span class="area-tag">Organisation</span>
                                <span class="area-tag">R&D et ingénierie</span>
                                <span class="area-tag">Ventes et marketing</span>
                            </div>
                        </div>

                        <div class="results-section">
                            <h4>Résultats obtenus :</h4>
                            <ul class="results-list">
                                <li><strong>Analyse comparative</strong> avec des entreprises semblables</li>
                                <li><strong>Rapport complet</strong> avec forces et opportunités d'amélioration</li>
                                <li><strong>Benchmarking</strong> de vos résultats</li>
                                <li><strong>Priorités d'action</strong> pour améliorer la performance</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Step 2 -->
            <div class="col-lg-6 mb-4">
                <div class="step-card">
                    <div class="step-header">
                        <div class="step-number">02</div>
                        <div class="step-icon">
                            <i class="icofont-target"></i>
                        </div>
                    </div>
                    <h3>Établissement des priorités d'action</h3>
                    <div class="step-content">
                        <div class="action-list">
                            <div class="action-item">
                                <i class="icofont-comments"></i>
                                <div>
                                    <h4>Discussion avec les dirigeants</h4>
                                    <p>Sur les recommandations du rapport d'évaluation</p>
                                </div>
                            </div>
                            <div class="action-item">
                                <i class="icofont-settings"></i>
                                <div>
                                    <h4>Établissement des priorités</h4>
                                    <p>En fonction de vos objectifs et des ressources disponibles</p>
                                </div>
                            </div>
                            <div class="action-item">
                                <i class="icofont-lightbulb"></i>
                                <div>
                                    <h4>Identification des projets</h4>
                                    <p>Projets d'amélioration priorisés et résultats attendus</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Step 3 -->
            <div class="col-lg-6 mb-4">
                <div class="step-card">
                    <div class="step-header">
                        <div class="step-number">03</div>
                        <div class="step-icon">
                            <i class="icofont-graduation-cap"></i>
                        </div>
                    </div>
                    <h3>Formation-accompagnement de vos employés</h3>
                    <div class="step-content">
                        <div class="training-section">
                            <div class="training-item">
                                <div class="training-icon">
                                    <i class="icofont-users-alt"></i>
                                </div>
                                <div class="training-content">
                                    <h4>Choix des ressources externes</h4>
                                    <p>Choix des ressources externes compétentes parmi les suggestions soumises par BSTP-GN et vos propres contacts</p>
                                </div>
                            </div>
                            <div class="training-item">
                                <div class="training-icon">
                                    <i class="icofont-book"></i>
                                </div>
                                <div class="training-content">
                                    <h4>Formation et accompagnement</h4>
                                    <p>Activités de formation/accompagnement de vos employés pour implanter les projets d'améliorations choisis</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Step 4 -->
            <div class="col-lg-6 mb-4">
                <div class="step-card">
                    <div class="step-header">
                        <div class="step-number">04</div>
                        <div class="step-icon">
                            <i class="icofont-chart-line"></i>
                        </div>
                    </div>
                    <h3>Suivi des résultats</h3>
                    <div class="step-content">
                        <div class="monitoring-section">
                            <div class="monitoring-item">
                                <div class="monitoring-icon">
                                    <i class="icofont-refresh"></i>
                                </div>
                                <div class="monitoring-content">
                                    <h4>Suivis réguliers</h4>
                                    <p>Suivis réguliers de l'avancement des projets avec votre conseiller BSTP-GN</p>
                                </div>
                            </div>
                            <div class="monitoring-item">
                                <div class="monitoring-icon">
                                    <i class="icofont-crown"></i>
                                </div>
                                <div class="monitoring-content">
                                    <h4>Amélioration continue</h4>
                                    <p>Possibilité de suivi pour pousser plus loin l'amélioration (réservé aux membres)</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- CTA Section -->
<section class="cta-section">
    <div class="container">
        <div class="row">
            <div class="col-lg-12 text-center">
                <div class="cta-content">
                    <h2>Prêt à transformer votre entreprise ?</h2>
                    <p>Rejoignez notre programme d'amélioration continu et donnez à votre entreprise les outils pour exceller</p>
                    <div class="cta-buttons">
                        <a routerLink="/contact" class="btn btn-primary">
                            <i class="icofont-envelope"></i>
                            Nous contacter
                        </a>
                        <a href="https://www.qualifpme.bstpgn.com" target="_blank" class="btn btn-outline-primary">
                            <i class="icofont-user-plus"></i>
                            Rejoindre QualifPME
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
